import * as i0 from "@angular/core";
export var StorageItemEnum;
(function (StorageItemEnum) {
    StorageItemEnum["WidgetOptions"] = "widgetOptions";
    StorageItemEnum["Locale"] = "locale";
    StorageItemEnum["GroupRestriction"] = "GroupRestriction";
    StorageItemEnum["UserAppId"] = "userAppId";
    StorageItemEnum["RememberMeEmail"] = "rememberMeEmail";
    StorageItemEnum["LabelConversionSeen"] = "labelConversionSeen";
    StorageItemEnum["DefaultGroupEdit"] = "defaultGroupEdit";
    StorageItemEnum["DefaultCollectionId"] = "defaultCollectionId";
})(StorageItemEnum || (StorageItemEnum = {}));
export var SessionStorageEnum;
(function (SessionStorageEnum) {
    SessionStorageEnum["UserMessagesSeen"] = "userMessagesSeen";
})(SessionStorageEnum || (SessionStorageEnum = {}));
var StorageService = /** @class */ (function () {
    function StorageService() {
    }
    StorageService.prototype.getLocalItem = function (key) {
        return localStorage.getItem("" + key);
    };
    StorageService.prototype.getLocalJSON = function (key) {
        var value = this.getLocalItem(key);
        return value ? JSON.parse(value) : null;
    };
    StorageService.prototype.setLocalItem = function (key, value) {
        var serializedValue = typeof (value) === 'object' ? JSON.stringify(value) : "" + value;
        try {
            localStorage.setItem("" + key, serializedValue);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    StorageService.prototype.removeLocalItem = function (key) {
        localStorage.removeItem("" + key);
    };
    StorageService.prototype.getSessionItem = function (key) {
        var entry = sessionStorage.getItem("" + key);
        if (entry) {
            return JSON.parse(entry);
        }
        else {
            return null;
        }
    };
    StorageService.prototype.setSessionItem = function (key, entry) {
        var json = JSON.stringify(entry);
        try {
            sessionStorage.setItem("" + key, json);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    StorageService.prototype.removeSessionItem = function (key) {
        sessionStorage.removeItem("" + key);
    };
    StorageService.prototype.clearStorage = function () {
        this.clearLocalStorage();
        this.clearSessionStorage();
    };
    StorageService.prototype.clearLocalStorage = function () {
        localStorage.clear();
    };
    StorageService.prototype.clearSessionStorage = function () {
        sessionStorage.clear();
    };
    StorageService.ngInjectableDef = i0.defineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());
export { StorageService };
